// extracted by mini-css-extract-plugin
export default {"root":"zMgAq552FhlIgd0NxBgI","icon":"rWSbqYBJ3Q0m0FxWdi9v","message":"hGGTWhXq3LLHvhDTx88O rWSbqYBJ3Q0m0FxWdi9v"};